import { FC } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles/createTheme";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Button } from "@mui/material";

export const HomeGraphs: FC = () => {
  const { t } = useTranslation();
  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("sm"));

  const images = [
    "assets/dashboard/dashboard1.png",
    "assets/dashboard/dashboard2.png",
    "assets/dashboard/dashboard3.png",
    "assets/dashboard/dashboard4.png",
  ];

  return (
    <div>
      <Box
        sx={{
          backgroundColor: "common.white",
          py: 12,
        }}
      >
        <Container maxWidth="lg">
          <Stack
            justifyContent="center"
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
            spacing={3}
          >
            <Typography
              component="h2"
              align="center"
              variant="h3"
              sx={{ mt: 2, mb: 2, color: "primary.main" }}
            >
              {t("Opensource Clinic Portal")}
            </Typography>

            <Typography align="center" color="text.secondary" variant="body1">
              {t("Configure your Nightscout, get new insights.")}
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",

                width: "100%",
                maxWidth: "800px",
                margin: "0 auto",
              }}
            >
              <Carousel
                autoPlay
                infiniteLoop
                showThumbs={false}
                showStatus={false}
                dynamicHeight
                interval={3000}
                transitionTime={1000}
              >
                {images.map((image, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // height: "400px", // Adjust height as needed
                      "& img": {
                        borderRadius: "15px",
                        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
                        transition: "transform 0.5s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.05)",
                        },
                      },
                    }}
                  >
                    <img
                      src={image}
                      alt={`Opensource Clinic Portal dashboard screenshot ${
                        index + 1
                      } showing diabetes data visualization and Nightscout configuration`}
                    />
                  </Box>
                ))}
              </Carousel>
            </Box>
            <Box sx={{ height: 5 }} />
            {/* <Typography align="center" color="text.secondary" variant="body1">
              {t("Still doubting?")}
            </Typography> */}
            <Button
              variant="contained"
              href="mailto:info@opensource.clinic"
              size={"medium"}
              target="_blank"
              sx={{
                borderRadius: 5,
              }}
            >
              {t("Contact us for a demo")}
            </Button>
          </Stack>
        </Container>
      </Box>
    </div>
  );
};
